export const HUB_EXTRAS_REGISTRATION_ENABLED = "Enabled";
export const HUB_EXTRAS_REGISTRATION_DISABLED = "Disabled";

export const HUB_EXTRAS_ACCESS_OPEN = "Open";
export const HUB_EXTRAS_ACCESS_ONLY_ADVANCED_USER = "onlyAdvancedUsers";
export const HUB_EXTRAS_ACCESS_ONLY_SUPERADMIN = "onlySuperadmin";
